import React, { Fragment, useState } from "react";
import { Image, Button } from "react-bootstrap";
import moment from "moment";
import CallingButtonPopup from "../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../../../reusableComponents/allPopupReusable/SendSmsButton";
import NotificationButton from "../../../../reusableComponents/allPopupReusable/NotificationButton";
import { PopupIconButtonReusable } from "../../../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";

import DeletePopup from "../../../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import LocationReusable from "../../../../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import EditWaitTime from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/EditWaitTime";
import NewCountDown from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import EditDiner from "../../../seatingDashboard/EditDiner";
import ViewDiner from "../../../seatingDashboard/ViewDiner";

export const TableBodyAll = (props) => {
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props.dinerInfo.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(props.dinerInfo.wait_time_date || props.dinerInfo.updatedAt);
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = props.dinerInfo.wait_time * 60 * 1000;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(props.dinerInfo.seatedTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " hh : " + nMinutesSeated + " mins";
  }

  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const [extra, setExtra] = React.useState(
    props.pathname === "/offline-events-booked" ||
      props.pathname === "/offline-events-history"
      ? true
      : false
  );
  const [displayDropDown, setdisplayDropDown] = useState(false);
  const onNextHoursOpen = (e) => {
    setdisplayDropDown(!displayDropDown);
  };
  return (
    <Fragment>
      {/* <div className="seating-dashboard-body"> */}
      <>
        {props.displayGrid ? null : (
          <div className="col-12 today-date-dropdown-seating-dashboard">
            <div>
              <h4>Today, {moment().format("Do MMM YYYY")}</h4>
            </div>
            <div className="seating-dashboard-today-line">
              <hr className="line" />
            </div>
          </div>
        )}

        <div className="col-12 mb-4">
          <div className="seating-dashboard-next-hours">
            <div className="dropdown_box b_c_red" onClick={onNextHoursOpen}>
              {props.displayDropDown ? (
                <i className="fa fa-angle-up c_white" aria-hidden="true"></i>
              ) : (
                <i className="fa fa-angle-down c_white" aria-hidden="true"></i>
              )}
            </div>
            <h5 className="font_20_m c_red ml-3">With-in next hour</h5>
          </div>
        </div>
      </>
      <tbody className="w-100 seating-dashboard-body-new">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr
                  className={`cursor enGrayBorderBox sd_body_tr ${
                    props.dinerInfo.service_type === "RESERVATION"
                      ? "td_b_o"
                      : "td_b_g"
                  }`}
                  onClick={showTr}
                >
                  <td
                    className={
                      props.dinerInfo.isWalkIn === true ||
                      props.dinerInfo.isWalkIn === false
                        ? "td_b_g order-type-Image"
                        : "td_b_o order-type-Image"
                    }
                    style={{ width: "6%" }}
                  >
                    {props.dinerInfo.isWalkIn === true &&
                    props.dinerInfo.service_type === "SEATING" ? (
                      <Image
                        src={require("../../../../../assets/images/ActionImages/image/walkin.svg")}
                        alt="Order Type"
                        title="Order Type"
                      />
                    ) : null ||
                      (props.dinerInfo.isWalkIn === false &&
                        props.dinerInfo.service_type === "SEATING") ? (
                      <Image
                        src={require("../../../../../assets/images/ActionImages/image/waitlist.svg")}
                        alt="Order Type"
                        title="Order Type"
                      />
                    ) : null ||
                      props.dinerInfo.service_type === "RESERVATION" ? (
                      <Image
                        src={require("../../../../../assets/images/ActionImages/image/reservation.svg")}
                        alt="Order Type"
                        title="Order Type"
                      />
                    ) : null}
                  </td>
                  <td style={{ width: "19%" }}>
                    <h4 className="font_20_m">{props.dinerName}</h4>
                    <p className="font_12_r">#{props.dinerInfo.diner_id}</p>
                  </td>
                  <td style={{ width:  "25%" }}>
                    <div className="total-pax-body">
                      <div className="col d-flex p-0">
                        <div className="total-pax-body-inside">
                          <h4 className="font_24_b">
                            {props.dinerInfo.adult_count +
                              props.dinerInfo.kids_count}
                          </h4>
                          {/* <p className="total-pax-light-text">PAX</p> */}
                        </div>
                        <div className="total-adult-kids">
                          <div className="display-align">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/image/adult.svg")}
                              alt="Adult"
                              title="Adult"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.adult_count}
                            </p>
                          </div>
                          <div className="display-align">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/image/kids.svg")}
                              alt="Kids"
                              title="Kids"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.kids_count}
                            </p>
                          </div>
                        </div>
                        <div className="total-highchair-handicapp">
                          {/* {props.dinerInfo.high_chair === 0 ? null : ( */}
                          <div className="display-align">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/image/highchair.svg")}
                              alt="Highchair"
                              title="Highchair"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.high_chair}
                            </p>
                          </div>
                          {/* )}
                    {props.dinerInfo.handicap_chair === 0 ? null : ( */}
                          <div className="display-align">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/image/handicap.svg")}
                              alt="Handicapped"
                              title="Handicapped"
                              className="pax-type-Image"
                            />
                            <p className="font_12_m ml-1 mr-1">
                              {props.dinerInfo.handicap_chair}
                            </p>
                          </div>
                          {/* )} */}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td style={{ width:  "25%" }}>
                    <div className="date-time-timer-body">
                      <div className="time-and-edit-button">
                        <div className="timer-section mr-2">
                          <h4 className="timer-count">
                            <NewCountDown waitNew={diff} />
                          </h4>
                        </div>
                        {/* <EditWaitTime allDataProps={props.dinerInfo._id} /> */}
                      </div>
                    </div>

                    <p className="font_20_r">
                      {props.dinerInfo.service_type === "RESERVATION"
                        ? moment(props.dinerInfo.reservationTime).format(
                            "Do MMM YYYY"
                          )
                        : moment(props.dinerInfo.createdAt).format(
                            "Do MMM YYYY"
                          )}
                    </p>
                    <p className="font_20_r">
                      {props.dinerInfo.service_type === "RESERVATION"
                        ? moment(props.dinerInfo.reservationTime).format(
                            "hh:mm A"
                          )
                        : moment(props.dinerInfo.createdAt).format("hh:mm A")}
                    </p>
                  </td>
                  <td style={{ width: "25%" }}>
                    <h4 className="font_20_m">
                      {props.dinerInfo.seating_preference[0]}
                    </h4>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </Fragment>
  );
};
